import React from "react";
import { Link } from "react-router-dom";

import ToolTip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";

export default ({ buttonText, linkTo, tip, btnClassName }) => (
  <ToolTip title={tip}>
    <Button
      component={Link}
      to={linkTo}
      size="small"
      className={btnClassName}
      color="inherit"
    >
      {buttonText}
    </Button>
  </ToolTip>
);
